module.exports = __webpack_public_path__ + "img/5e872d7a79a51f47ba048ec39da2c1bd.5e872d7a.png";